import { Home, Box, Users, ShoppingBag, Mail, Bookmark ,Inbox} from 'react-feather';
import { useSelector } from 'react-redux';
import { selectRoleId } from '../../Redux/personalDetail';

export const MENUITEMS = () => {
      const roleId = useSelector(selectRoleId);
 return [
    {
        menutitle: 'General',
        Items: [
            // { path: `${process.env.PUBLIC_URL}/app/file-manager`, icon: GitPullRequest, title: 'file Manger', bookmark: true, type: 'link' },
            { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`, icon: Home, title: 'Dashboard', bookmark: true, type: 'link' },
            {
                title: 'Subscriptions', icon: Box, type: 'sub', active: false, children: [
                    { path: `${process.env.PUBLIC_URL}/subscriptions/active-sub`, title: 'Active Subscribers', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/subscriptions/temp-sub`, title: 'Temporary Subscribers', type: 'link'  },
                    { path: `${process.env.PUBLIC_URL}/subscriptions/trial-expired`, title: 'Trial Expired', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/subscriptions/expiredSubscription`, title: 'Expired Subscription', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/subscriptions/paymentDueSubscription`, title: 'Payment Due Subscription', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/subscriptions/company-created-users`, title: 'Users Without Subscription', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/subscriptions/users`, title: 'Users', type: 'link' },
                ].filter(Boolean) 
            },
            {
                title: 'Billing', icon: ShoppingBag, type: 'sub', active: false, children: [
                   { path: `${process.env.PUBLIC_URL}/billing/invoice-list`, title: 'Invoice', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/billing/payment-list`, title: 'Payment', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/billing/subscription`, title: 'Subscription', type: 'link' },
                ]
            },
          
             {
                    title: 'Lead Manager', icon: Inbox, type: 'sub', active: false, children: [
                        { path: `${process.env.PUBLIC_URL}/lead-manage/enquiry`, title: 'Enquiries', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/lead-manage/leads`, title: 'Leads', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/lead-manage/follow-ups`, title: 'Follow-ups', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/lead-manage/overdue-follow-ups`, title: 'Overdues', type: 'link' },
                    ]
                },

            {
                title: 'Report', icon: Bookmark, type: 'sub', active: false, children: [
                 { path: `${process.env.PUBLIC_URL}/reports/Package`, type: 'link', title: 'Plan Usage' },       
                 roleId === 1 && { path: `${process.env.PUBLIC_URL}/reports/NotifiactionCredit`, type: 'link', title: 'Notification Credit Payment' },
                 roleId === 1 && { path: `${process.env.PUBLIC_URL}/reports/MonthlyRevenueByIndustry`, type: 'link', title: 'Monthly Revenue By Industry' },
                 roleId === 1 && { path: `${process.env.PUBLIC_URL}/reports/MonthlyRevenueByCompany`, type: 'link', title: 'Monthly Revenue By Company' },
                 roleId === 1 && { path: `${process.env.PUBLIC_URL}/reports/MonthlyRevenueByPlan`, type: 'link', title: 'Monthly Revenue By Plan' },
                //  { path: `${process.env.PUBLIC_URL}/reports/MonthlyRevenue`, type: 'link', title: 'Monthly Revenue' },                
                roleId === 1 &&  { path: `${process.env.PUBLIC_URL}/reports/NotifiactionCreditUsage`, type: 'link', title: 'Notification Credit Usage' },                                                  
                //  { path: `${process.env.PUBLIC_URL}/reports/PendingPayment`, type: 'link', title: ' Pending Payment' },  
                roleId === 1 &&  { path: `${process.env.PUBLIC_URL}/reports/CouponUsage`, type: 'link', title: 'Coupon Usage' },                                                                                       
                ]
            },
          
            roleId === 1 && {
                title: 'Master Records', icon: Users, path: `${process.env.PUBLIC_URL}/app/users/userProfile`, type: 'sub', bookmark: true, active: false, children: [
                    { path: `${process.env.PUBLIC_URL}/master-records/role`, title: 'Role', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/master-records/Staff`, title: 'Staff', type: 'link' },
                    // { path: `${process.env.PUBLIC_URL}/master-records/role-add`, title: 'Add Role', type: 'link' },
                    // { path: `${process.env.PUBLIC_URL}/master-records/addons`, title: 'Addons', type: 'link' },
                    // { path: `${process.env.PUBLIC_URL}/master-records/addons-add`, title: 'Add Addons', type: 'link' },
                    // { path: `${process.env.PUBLIC_URL}/master-records/user-address`, title: 'Users Address', type: 'link' },
                    // { path: `${process.env.PUBLIC_URL}/master-records/user-address-add`, title: 'Add User Address', type: 'link' },
                ]
            },
              roleId === 1 && {
                title: 'Configuration', icon: Mail, type: 'sub', children: [
                    { path: `${process.env.PUBLIC_URL}/configuration/industry-list`, title: 'Industries', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/configuration/tax-list`, type: 'link', title: 'Tax Class' },
                    { path: `${process.env.PUBLIC_URL}/configuration/zone-list`, type: 'link', title: 'Zone' },
                    { path: `${process.env.PUBLIC_URL}/configuration/account`, title: 'Account', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/configuration/packages`, title: 'Packages', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/configuration/coupon`, title: 'Coupon', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/configuration/notification-channel`, title: 'Notification Channel', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/configuration/notification-settings`, title: 'Notification Settings', type: 'link' },
                    { path: `${process.env.PUBLIC_URL}/configuration/payment-method`, title: 'Payment Method', type: 'link' },
                ]
            },
        ].filter(Boolean)
    }
 ]
};
